module.exports = __webpack_public_path__ + "media/images/redesign-images/home/affiliate-collage-02cd20f1b03578b2c887ea51e1486209.jpg";